<script>
    import { page } from '$app/stores';
    import { img_cdn } from './utils/image';

    export let sm = false;
    let className = '';
    export { className as class };

    $: links = $page.data.social_links || [];
</script>

<div
    class="flex nowrap mx-auto gap-4 items-center justify-center max-w-md {className}"
>
    {#each links as link}
        <a
            href={link.url}
            class="opacity-90 hover:opacity-100 transition-opacity"
            target="_blank"
            ><img
                src={img_cdn(link.icon)}
                alt={link.name}
                class="aspect-square {sm ? 'w-6' : 'w-8'}"
                loading="lazy"
            /></a
        >
    {/each}
</div>
